import { Component, Input } from '@angular/core';

/**
 * Displays a widget that contains a small amount of information relevant to the user.  This can include
 * text as well as badge counters to let users know when new information has become available.
 */
@Component({
  selector: 'dashboard-feature-tile',
  templateUrl: './feature-tile.component.html',
  styleUrls: ['./feature-tile.component.scss'],
})
export class DashboardFeatureTileComponent {
  /**
   * Displays header like static text in the tile
   */
  @Input() bText = '';

  /**
   * Displays a badge count if applicable to the right of the tile
   */
  @Input() bCount = 0;

  /**
   * Sets the color of the tile
   */
  @Input() color = 'purple-500';

  /**
   * An optional icon do display
   */
  @Input() icon = '';

  /**
   * A size value that controls how the component is rendered
   */
  @Input() size: 'small' | 'medium' = 'medium';

  /**
   * Controls whether the accordion section is expanded or not
   */
  @Input() toggle = false;

  /**
   * Renders some extra optional text in the body of the tile
   */
  @Input() bodyContent = '';

  // To toggle visibility of accordion.
  expanded = false;
}
